export const CHART_CONFIG = {
  HEIGHT: "750px",
  MARGIN: { top: 20, right: 30, left: 40, bottom: 40 },
  AXIS: {
    fontSize: 11,
    stroke: "#64748b",
  },
};

export const METRICS = [
  { key: "cip_rate", label: "CIP" },
  { key: "alerts", label: "Alerts" },
  { key: "time_waste_s", label: "Excessive Time" },
  { key: "water_waste_l", label: "Water Loss" },
  { key: "chemical_waste_l", label: "Chemical Loss" },
];

export const VIEW_MODES = [
  { key: "object", label: "Objects" },
  { key: "line", label: "Lines" },
  { key: "recipe", label: "Recipes" },
];

export const INITIALLY_DESELECTED = {
  alerts: new Set(["80"]),
  lines: new Set([]),
  recipes: new Set([]),
  objects: new Set([]),
};

// Base formatters that can be extended with dynamic converters
export const formatters = {
  alerts: (count) => count.toLocaleString(),
  number: (value) => value.toLocaleString(),
  // These will be overridden in components with actual converter functions
  volume: (liters) => liters.toLocaleString(),
  time: (seconds) => seconds.toLocaleString(),
};
